import { NormalizedPaymentMethod } from '~/models/NormalizedPaymentMethod';
import { PaymentMethod } from '~/models/PaymentMethod';

/** Format the payment method object in a generic format regardless of payment method type. */
export const normalizePaymentMethod = (paymentMethod: PaymentMethod): NormalizedPaymentMethod => {
    switch (paymentMethod.type) {
        case 'card':
            return {
                label: 'Credit Card',
                type: 'card',
                id: paymentMethod.id,
                name: paymentMethod?.card?.brand,
                lastFour: paymentMethod?.card?.lastFour || '',
                country: paymentMethod?.card?.countryCode || ''
            };
        case 'vinovest_funds':
            return {
                label: 'Account Funds',
                type: 'vinovest_funds',
                id: paymentMethod.id,
                name: paymentMethod?.name
            };
        // all others by default
        default:
            return {
                label: 'Bank Transfer',
                type: 'ach',
                id: paymentMethod.accountID || paymentMethod.id,
                name:
                    paymentMethod?.ach?.name?.toUpperCase() ||
                    paymentMethod?.name?.toUpperCase() ||
                    paymentMethod?.bank?.name?.toUpperCase(),
                lastFour: paymentMethod?.ach?.lastFour || paymentMethod?.lastFour || paymentMethod?.bank?.lastFour,
                country: ''
            };
    }
};
